var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUtilization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 29.8703V34.1667C35 34.9432 35 35.3315 34.8732 35.6378C34.704 36.0462 34.3795 36.3707 33.9712 36.5398C33.6648 36.6667 33.2765 36.6667 32.5 36.6667C31.7235 36.6667 31.3352 36.6667 31.0288 36.5398C30.6205 36.3707 30.296 36.0462 30.1268 35.6378C30 35.3315 30 34.9432 30 34.1667C30 33.3902 30 33.0018 29.8732 32.6955C29.704 32.2872 29.3795 31.9627 28.9712 31.7935C28.6648 31.6667 28.2765 31.6667 27.5 31.6667H10.8333C10.0568 31.6667 9.66848 31.6667 9.3622 31.7935C8.95382 31.9627 8.62935 32.2872 8.4602 32.6955C8.33333 33.0018 8.33333 33.3902 8.33333 34.1667C8.33333 34.9432 8.33333 35.3315 8.20647 35.6378C8.03732 36.0462 7.71285 36.3707 7.30447 36.5398C6.99818 36.6667 6.6099 36.6667 5.83333 36.6667C5.05677 36.6667 4.66848 36.6667 4.3622 36.5398C3.95382 36.3707 3.62935 36.0462 3.4602 35.6378C3.33333 35.3315 3.33333 34.9432 3.33333 34.1667V29.8703C3.33333 27.8667 3.33333 26.8647 3.61938 25.92C3.90543 24.9752 4.46118 24.1415 5.57267 22.4743L6.66667 20.8333L8.1688 17.5287C9.46265 14.6822 10.1096 13.2589 11.346 12.4628C12.5824 11.6667 14.1457 11.6667 17.2725 11.6667H21.0608C24.1877 11.6667 25.751 11.6667 26.9873 12.4628C28.2238 13.2589 28.8707 14.6822 30.1645 17.5287L31.6667 20.8333L32.7607 22.4743C33.8722 24.1415 34.4278 24.9752 34.714 25.92C35 26.8647 35 27.8667 35 29.8703Z",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 18.3333L6.66667 20.8333L9.6019 21.5672C9.8663 21.6332 10.1378 21.6667 10.4104 21.6667H27.923C28.1955 21.6667 28.467 21.6332 28.7315 21.5672L31.6667 20.8333L35 18.3333",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 26.6667V26.6833",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26.6667V26.6833",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 11.6667C31.6667 9.82572 30.1743 8.33333 28.3333 8.33333",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 11.6667C36.6667 7.0643 32.9357 3.33333 28.3333 3.33333",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUtilization);
export default __webpack_public_path__ + "static/media/icon_utilization.9f7e63b17a1df06a7d8393a3b68b859b.svg";
export { ForwardRef as ReactComponent };